/**
 * @generated SignedSource<<7770a5c6f180f427e9faf366a542c8c2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type scmpPwaBurgerMenuConfigAppConfigQuery$variables = Record<PropertyKey, never>;
export type scmpPwaBurgerMenuConfigAppConfigQuery$data = {
  readonly appConfig: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
};
export type scmpPwaBurgerMenuConfigAppConfigQuery = {
  response: scmpPwaBurgerMenuConfigAppConfigQuery$data;
  variables: scmpPwaBurgerMenuConfigAppConfigQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "entityId": "scmp_pwa_burger_menu"
    }
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "scmpPwaBurgerMenuConfigAppConfigQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "AppConfig",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_burger_menu\"})"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "scmpPwaBurgerMenuConfigAppConfigQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "AppConfig",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_burger_menu\"})"
      }
    ]
  },
  "params": {
    "cacheID": "9e3afcf791443379efb64c39e732c8e4",
    "id": null,
    "metadata": {},
    "name": "scmpPwaBurgerMenuConfigAppConfigQuery",
    "operationKind": "query",
    "text": "query scmpPwaBurgerMenuConfigAppConfigQuery {\n  appConfig(filter: {entityId: \"scmp_pwa_burger_menu\"}) {\n    json\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ca9b160847310d9fd8662817493dbdcd";

export default node;
